// dbext:profile=staging_mcdo2019_be

import $ from "jquery";

// polyfill for IE11 (was @babel\polyfill, but was deprecated in favor of direct imports of corejs and regenerator-runtime)
import "core-js/stable";
import "regenerator-runtime/runtime";

import admin_general                              from './905-admin_general.js'                             ;
import admin_products                             from './920-admin_products.js'                            ;
import admin_related_products_groupings           from './921-admin_related_products_groupings.js'          ;
import admin_categories                           from './922-admin_categories.js'                          ;
import admin_ingredients                          from './925-admin_ingredients.js'                         ;
import admin_restaurants                          from './930-admin_restaurants.js'                         ;
import admin_restaurants_scheduled_tasks_overview from './934-admin-restaurants_scheduled_tasks_overview.js';
import admin_openinghours_schedule                from './933-admin-restaurant_openinghours_schedule.js'    ;
import admin_services                             from './935-admin_services.js'                            ;
import admin_jobs                                 from './940-admin_jobs.js'                                ;

$(function(){

    // go running
    admin_general                             .init();
    admin_products                            .init();
    admin_related_products_groupings          .init();
    admin_ingredients                         .init();
    admin_categories                          .init();
    admin_restaurants                         .init();
    admin_openinghours_schedule               .init();
    admin_restaurants_scheduled_tasks_overview.init();
    admin_services                            .init();
    admin_jobs                                .init();
});

